

// FancyDressActivity
import React from 'react';
import FieldTrip52025 from 'views/FieldTrip52025';

const FancyDressActivityPage = () => {
  return <FieldTrip52025/>;
};

export default FancyDressActivityPage;